export interface NotificationSettings {
  browser: boolean;
  sound: boolean;
  desktop: boolean;
  vibration: boolean;
}

export interface NotificationStorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
  browser: false,
  sound: true,
  desktop: false,
  vibration: false,
};

const STORAGE_KEY = 'notificationSettings';

export function readNotificationSettings(storage: NotificationStorageLike): NotificationSettings {
  try {
    const saved = storage.getItem(STORAGE_KEY);
    if (!saved) {
      return DEFAULT_NOTIFICATION_SETTINGS;
    }

    return {
      ...DEFAULT_NOTIFICATION_SETTINGS,
      ...JSON.parse(saved),
    };
  } catch {
    return DEFAULT_NOTIFICATION_SETTINGS;
  }
}

export function writeNotificationSettings(
  storage: NotificationStorageLike,
  settings: NotificationSettings
): NotificationSettings {
  storage.setItem(STORAGE_KEY, JSON.stringify(settings));
  return settings;
}

export function enableBrowserNotifications(storage: NotificationStorageLike): NotificationSettings {
  const current = readNotificationSettings(storage);
  return writeNotificationSettings(storage, {
    ...current,
    browser: true,
  });
}
